

































































































import { Alert, NoticeClass } from '@kasasa/fbase-components/lib';
import { DailyLoadFilter } from '@/api/dashboard/DailyLoadFilter';
import { SavedDailyLoadFilter } from '@/api/dashboard/SavedDailyLoadFilter';
import { SavedDailyLoadFilterResource } from '@/api/dashboard/SavedDailyLoadFilterResource';
import DailyLoadCreateFilterSubDialog from '@/components/dailyload/dailyloadcreatefiltersubdialog.vue';
import Vue from 'vue';
import {
  Component, Prop, Watch, Inject,
} from 'vue-property-decorator';

@Component({
  components: {
    DailyLoadCreateFilterSubDialog,
  },
})
export default class DailyLoadCreateFilterDialog extends Vue {
  @Prop({ default: false }) value!: boolean;

  @Prop({ default: false }) loading!: boolean;

  @Prop({ default: () => [] }) existingFilters!: SavedDailyLoadFilter[];

  @Prop() workingFilter!: DailyLoadFilter;

	@Inject('SavedDailyLoadFilterResource')
	savedDailyLoadFilterResource!: SavedDailyLoadFilterResource;

  showDialog: boolean = false;

  globalFilter: boolean = false;

  selectedFilter: SavedDailyLoadFilter | string | null = null;

  isFormValid: boolean = false;

  saving: boolean = false;

  showSubDialog:boolean = false;

  overwriteConfirmed:boolean = false;

  @Watch('value')
  onValueChanged() {
    this.showDialog = this.value;
  }

  @Watch('showDialog')
  onShowDialogChanged() {
    this.$emit('input', this.showDialog);
  }

  @Watch('selectedFilter')
  onFilterNameChanged() {
    this.validateForm();
  }

  closeDialog() {
    this.selectedFilter = null;
    this.showDialog = false;
  }

  async saveFilter() {
    // Force the combo to lose focus so that changes aren't lost
    const combo: any = this.$refs.filterNameCombo;
    combo.blur();

    // wait one tick to allow updates on blur to take effect
    await this.$nextTick().then(() => {
      const saveFilter = this.getSaveFilter();

      // Intentionally saves without the date ranges
      saveFilter.filterJson.processingStartDate = null;
      saveFilter.filterJson.processingEndDate = null;

      if (saveFilter.id) {
        if (!this.overwriteConfirmed) {
          this.showSubDialog = true;
        } else {
          this.saving = true;
          this.savedDailyLoadFilterResource.updateFilter(saveFilter)
            .then((savedFilter) => {
              this.savedSuccessfully(savedFilter);
            })
            .catch((error: any) => {
              this.showError(`Error updating search filter: ${error}`);
            })
            .finally(() => { this.saving = false; });
        }
      } else {
        this.saving = true;
        this.savedDailyLoadFilterResource.saveFilter(saveFilter)
          .then((savedFilter) => {
            this.savedSuccessfully(savedFilter);
          })
          .catch((error: any) => {
            this.showError(`Error saving search filter: ${error}`);
          })
          .finally(() => { this.saving = false; });
      }
    });
  }

  async saveFilterConfirm() {
    this.overwriteConfirmed = true;
    await this.saveFilter();
    this.showSubDialog = false;
    this.resetDialog();
  }

  savedSuccessfully(savedFilter: SavedDailyLoadFilter) {
    // Filters aren't saved with the date ranges so they need to be restored before
    // this back to the parent, so the view can be updated with the selected range.
    const emitArgument = { ...savedFilter };
    emitArgument.filterJson.processingStartDate = this.workingFilter.processingStartDate;
    emitArgument.filterJson.processingEndDate = this.workingFilter.processingEndDate;
    this.$emit('filterSaved', emitArgument);
    this.closeDialog();
    this.showSuccess('Search filter saved successfully');
  }

  resetDialog() {
    this.globalFilter = false;
    this.selectedFilter = null;
    this.saving = false;
    this.overwriteConfirmed = false;
  }

  statusLabel() {
    const globalPrivateLabelText = this.globalFilter ? 'Global' : 'Private';
    return `Status: ${globalPrivateLabelText}`;
  }

  findFilterByName(): SavedDailyLoadFilter | null {
    if (typeof this.selectedFilter === 'string') {
      for (let i = 0; i < this.existingFilters.length; i++) {
        const filter: SavedDailyLoadFilter = this.existingFilters[i];
        if (filter.filterName === this.selectedFilter) {
          return filter;
        }
      }
      return null;
    }
    return this.selectedFilter;
  }

  getSaveFilter() : SavedDailyLoadFilter {
    const workingFilterCopy = { ...this.workingFilter };
    const existingFilter = this.findFilterByName();
    if (existingFilter) {
      const filterCopy = { ...existingFilter };
      filterCopy.filterJson = workingFilterCopy;
      return filterCopy;
    }

    return {
      filterName: this.getSelectedFilterName()!,
      isGlobal: this.globalFilter!,
      filterJson: workingFilterCopy,
    };
  }

  formNameRules() : boolean | string {
    if (!this.isFormNamePresent()) {
      return true;
    }

    if (this.getSelectedFilterName().length < 3) {
      return 'Filter name should be at least 3 characters';
    }

    if (this.getSelectedFilterName.length > 50) {
      return 'Filter name should be no more than 50 characters';
    }

    return true;
  }

  isFormNamePresent() {
    if (typeof this.selectedFilter === 'string') {
      return this.selectedFilter!.length > 0;
    }

    return this.selectedFilter !== null;
  }

  getSelectedFilterName() : string {
    if (typeof this.selectedFilter === 'string') {
      return this.selectedFilter;
    }

    if (this.selectedFilter !== null) {
      return this.selectedFilter.filterName;
    }

    return '';
  }

  showError(message: string) {
    const al = new Alert(message, NoticeClass.ERROR);
    al.setTimeout(5000);
    this.$store.dispatch('notices/add', al);
  }

  showSuccess(message: string) {
    const al = new Alert(message, NoticeClass.SUCCESS);
    al.setTimeout(5000);
    this.$store.dispatch('notices/add', al);
  }

  validateForm() {
    (this.$refs.filterNameForm as any).validate();
  }
}

